import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { IPackageReducer } from "../interfaces/IRedux";
import {
  getClientPackages,
  getClientArticlesForPackage,
  deleteClientPackage
} from "../actions/packageActions";

import { SimpleMapper } from "../components/mappers";
import CPackageCard from "../cards/CPackageCard";

import ClientPackageDetailModal from "../modals/ClientPackageDetailModal";

import { showModal, showPopUpConfirmation } from "../utils/domUtils";

interface ComponentProps {
  getClientPackages: Function;
  getClientArticlesForPackage: Function;
  package?: IPackageReducer;
}

class ClientDashboardPackages extends React.Component<ComponentProps, {}> {
  state = {
    idmodal_package_detail: "modal_package_detail",
    currentPackage: null,
  };

  componentDidMount() {
    this.getResults();
  }

  getResults() {
    this.props.getClientPackages();
  }

  getById(id) {
    return this.props.package.elements.find(
      (p) => p.id === id
    );
  }

  onShowPackageClick = (id) => {
    const selectedPackage = this.getById(id)
    if (!selectedPackage) return;

    this.props.getClientArticlesForPackage(id);
    this.setState(
      {
        currentPackage: selectedPackage,
      },
      () => {
        showModal(this.state.idmodal_package_detail);
      }
    );
  };

  onDeletePackageClick = (id) => {
    const selectedPackage = this.getById(id)
    if (!selectedPackage) return;

    showPopUpConfirmation('Confirmacion', `
    ¿Realmente desea eliminar el paquete "${selectedPackage.name}"? 
    Los articulos agregados se conservaran sin paquete asignado
    `, (confirmation) => {
      if(!confirmation) return;

      // @ts-ignore
      this.props.deleteClientPackage(id)
    })
  }

  render() {
    const { loading, elements } = this.props.package;
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <SimpleMapper
              loading={loading}
              elements={elements}
              component={CPackageCard}
              emptyMessage="No hay paquetes para mostrar, intenta creando uno"
              classNameContainer="container-grid"
              componentAditionalProps={{
                onShowPackageClick: this.onShowPackageClick,
                onDeletePackageClick: this.onDeletePackageClick
              }}
            />
          </div>
        </div>

        <ClientPackageDetailModal
          modal_id={this.state.idmodal_package_detail}
          currentPackage={this.state.currentPackage}
        />
      </>
    );
  }
}

// @ts-ignore
ClientDashboardPackages.propTypes = {
  package: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  package: state.package,
});

export default connect(mapStateToProps, {
  getClientPackages,
  getClientArticlesForPackage,
  deleteClientPackage
})(ClientDashboardPackages);
